import { Boundaries } from "@planzone/core";
import { preferences } from "@planzone/dto";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  preferences,
};

function handleRequest(state: State): State {
  return { ...initialState, request: setRequestStateToPending() };
}

function handleSuccess(
  state: State,
  { preferences }: Boundaries["retrieveUserPreferences"]["success"],
): State {
  return { preferences, request: setRequestStateToSuccess() };
}

function handleFailure(state: State): State {
  return { ...initialState, request: setRequestStateToFailure() };
}

function handlePreferencesEdition(
  state: State,
  { preferences }: Boundaries["editUserPreferences"]["success"],
): State {
  return { ...state, preferences };
}

const reduceState = createStateReducer(initialState, {
  [events.retrieveUserPreferencesRequested]: handleRequest,
  [events.retrieveUserPreferencesSucceeded]: handleSuccess,
  [events.retrieveUserPreferencesFailed]: handleFailure,
  [events.editUserPreferencesSucceeded]: handlePreferencesEdition,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
